import Query from '../Query';

export default function ConsoleLog(query: Query): Query {
  // eslint-disable-next-line no-console
  console.info(query.result.content);

  return query;
}
